export * from './snackbar'
export * from './dialog'

export const CLINIC_HASH_SESSION_STORAGE_KEY = 'lpu_hash'

export const CLINIC_SOURCE_SESSION_STORAGE_KEY = 'lpu_source'
